// src/App.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import PrivateRoute from "./auth/PrivateRoute";
import AdminRoute from "./auth/AdminRoute";

import AppLayout from "./layouts/AppLayout";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import AddNewPartner from "./pages/AddNewPartner";
import AddNewPayment from "./pages/AddNewPayment";
import PaymentDetails from "./pages/PaymentDetails";

// ✅ add this import (adjust path if your file is elsewhere)
import { DashboardCacheProvider } from "./utils/DashboardCacheContext";

import "./index.css";

function App() {
	document.title = "Fconnect Partner Dashboard";

	return (
		<AuthProvider>
			<DashboardCacheProvider>
				<Routes>
					{/* Public */}
					<Route
						path="/login"
						element={<LoginPage />}
					/>

					{/* Root redirect (protected) */}
					<Route
						path="/"
						element={
							<PrivateRoute>
								<Navigate
									to="/dashboard"
									replace
								/>
							</PrivateRoute>
						}
					/>

					{/* Authenticated routes */}
					<Route
						path="/dashboard"
						element={
							<PrivateRoute>
								<AppLayout>
									<Dashboard />
								</AppLayout>
							</PrivateRoute>
						}
					/>

					<Route
						path="/PaymentDetails"
						element={
							<PrivateRoute>
								<AppLayout>
									<PaymentDetails />
								</AppLayout>
							</PrivateRoute>
						}
					/>

					{/* Admin-only routes */}
					<Route
						path="/AddNewPartner"
						element={
							<PrivateRoute>
								<AdminRoute>
									<AppLayout>
										<AddNewPartner />
									</AppLayout>
								</AdminRoute>
							</PrivateRoute>
						}
					/>

					<Route
						path="/AddNewPayment"
						element={
							<PrivateRoute>
								<AdminRoute>
									<AppLayout>
										<AddNewPayment />
									</AppLayout>
								</AdminRoute>
							</PrivateRoute>
						}
					/>

					{/* Fallback */}
					<Route
						path="*"
						element={
							<Navigate
								to="/login"
								replace
							/>
						}
					/>
				</Routes>
			</DashboardCacheProvider>
		</AuthProvider>
	);
}

export default App;
